import React from 'react'
import {Tag} from 'antd'
import * as TypeUtil from '../util/TypeUtil'
//import { Link } from 'react-router-dom'

export const TAGS = 'tags'

export default class Tags extends React.Component {
  state={}
  componentDidMount() {
    this.setup()
  }
  setup() {
    const props = this.props
    if (TypeUtil.isObject(props)) {
      const key = props.key||TAGS
      if (TypeUtil.isNonEmptyString(key)) {
        const match = props.match
        if (TypeUtil.isObject(match)) {
          const params = match.params
          if (TypeUtil.isObject(params)) {
            const value = params[key]
            if (TypeUtil.isNonEmptyString(value)) {
              const values = value.split('+')
              if (TypeUtil.isNonEmptyArray(values)) {
                this.setState({
                  key:key,
                  values:values
                })
              }
            }
          }
        }
      }
    }
  }
  to(value) {
    const {key,values} = this.state
    if (TypeUtil.isNonEmptyString(key) && TypeUtil.isNonEmptyArray(values)) {
      if (typeof(value)==='string'&&value.length>0) {
        const index = values.findIndex(e=>e===value)
        if (index>=0) {
          const copy = values.slice()
          copy.splice(index,1)
          if (copy.length<=0) {
            if (TypeUtil.isNonEmptyString(this.props.backLink)) {
              return this.props.backLink
            }
            return '/'
          }
          return `/search/${key}/${copy.join('+')}`
        }
      }
      return `/search/${key}/${values.join('+')}`
    }
    return '/'
  }
  handleClick=e=>{
    const {onTag} = this.props
    if (typeof(onTag)==='function') {
      onTag(e)
    }
  }
  render() {
    const {className,values,onClick} = this.props
    if (Array.isArray(values)&&values.length>0) {
      return (
        <div className={className||''} onClick={onClick}>
          {
            values.map((e,i)=>{
              const {name} = e
              return (
                <Tag key={i} color="magenta" className="mr-1 mb-1" onClick={event=>{
                  event.preventDefault()
                  event.stopPropagation()
                  this.handleClick(e)
                }}>{name}</Tag>
              )
            })
          }
        </div>
      )
    }
    return null
  }
}
